import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcInputStyles } from 'components/filter/MprcInputStyles';
import { AutoCompleteHierarchicalModel } from 'components/MprcAutoCompleteHierarchical';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TopicAutoCompleteHierarchical } from 'views/foundation/topic/components/TopicAutoCompleteHierarchical';
import { IAdvFilterPickerProps } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const TopicHierarchicalPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel, onError } = props;
    const { t } = useTranslation("shared");
    const [selected, setSelected] = useState<AutoCompleteHierarchicalModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);
    const multiSelect = filter.canRepeat ?? false;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            const newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label} ${item.includeDescendants ? " [+]" : ""}`,
                value: item!.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: item.includeDescendants
            }));
            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <TopicAutoCompleteHierarchical
                    autoFocus
                    selectedMode="free"
                    multiSelect={multiSelect}
                    showDescendantOption
                    placeholder={t(`AdvFilter.Picker.Topic.Placeholder${multiSelect ? "_multi" : ""}`)}
                    selectedItems={selected}
                    color="warning"
                    onChange={(items) => setSelected(items as AutoCompleteHierarchicalModel[])}
                    applyEnter={{ onApply: handleApply, behavior: "SelectionOptionsEmpty" }}
                    onCancel={onCancel}
                    onError={onError}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
